import type { TranslationDict } from './ja'

export const vi: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Cách chơi',
  helpAria: 'Cách chơi',
  settings: 'Cài đặt',
  settingsAria: 'Cài đặt',
  close: 'Đóng',
  closeAria: 'Đóng',
  player: 'Người chơi',
  highscore: 'Điểm cao',
  start: 'Bắt đầu',
  staminaEmpty: 'Không đủ thể lực',
  ranking: 'Đấu Lãnh Thổ',
  difficultyTitle: 'Chọn độ khó',
  difficultyStart: 'Bắt đầu với độ khó này',
  back: 'Quay lại',
  today: 'Hôm nay',
  weekly: 'Tuần này',
  alltime: 'Tổng',
  loading: 'Đang tải...',
  noScores: 'Chưa có thành tích. Hãy là nhà vô địch đầu tiên!',
  loadFailed: 'Tải thất bại',
  you: 'Bạn',
  youConstant: 'BẠN',
  language: 'Ngôn ngữ',
  languageNote: 'Hỗ trợ 18 ngôn ngữ, bao gồm tiếng Nhật.',
  bgm: 'BGM',
  se: 'Hiệu ứng âm thanh',
  soundEnableAria: 'Bật âm thanh',
  soundDisableAria: 'Tắt âm thanh',
  adWatch: 'Xem quảng cáo đến hết',
  adCancel: 'Để sau',
  rankSuffix: '',
  earnedPoints: 'đã đạt {score} điểm',
  helpGoalTitle: '🎯 Mục tiêu',
  helpGoalText: 'Đặt quân trên bàn cờ 9x9 và mở rộng lãnh thổ được kết nối. Ai có điểm cao hơn sẽ thắng.',
  helpWinTitle: '🏆 Điều kiện thắng',
  helpWinFive: 'Xếp năm quân liên tiếp theo hàng dọc, ngang hoặc chéo để thắng ngay lập tức.',
  helpWinScore: 'Nếu bàn cờ đầy, người có điểm cao hơn sẽ thắng. Không có hòa.',
  helpScoreTitle: '💯 Cách tính điểm',
  helpLineBonus: 'Thưởng hàng: nhận điểm cho các hàng 3, 4 và 5 quân liên tiếp.',
  helpClusterBonus: 'Thưởng lãnh thổ: điểm càng cao khi nhóm quân kết nối càng lớn.',
  helpKomi: 'Komi: người đi sau nhận được thêm +10% điểm thưởng.',
  helpControlsTitle: '🖱️ Điều khiển',
  helpControlsText: 'Đến lượt của bạn, chạm vào một ô trống để đặt quân.',
  helpTipsTitle: '💡 Mẹo',
  helpTipHell: 'Thử độ khó HELL khi bạn muốn thử thách cực hạn.',
  helpTipCluster: 'Đừng chỉ cố xếp năm quân liên tiếp. Các nhóm kết nối lớn cũng giúp tăng điểm đáng kể.',
  resultWinFive: '🎉 Năm quân liên tiếp! Bạn đã thắng!',
  resultWinScore: '🎉 Thắng bằng điểm số! Bạn đã thắng!',
  resultLoseFive: '😿 CPU đã xếp được năm quân liên tiếp!',
  resultLoseScore: '😿 Thua điểm. Hãy thử lại!',
  resultDraw: '🤝 Hòa',
  newHighscore: '🏆 Kỷ lục mới!',
  scoreNone: 'Chưa có điểm',
  clusterBonus: 'Thưởng lãnh thổ',
  retry: 'Chơi lại',
  titleBack: 'Trang chủ',
  scoreHintPlaceStone: 'Đặt một quân',
  best: 'Tốt nhất',
  clusterUnit: 'nhóm',
  lineCount: '{len} quân liên tiếp x{count}',
  turnCount: 'Lượt {count} · {difficulty}',
  boardPlayerPiece: 'Quân của bạn',
  boardCpuPiece: 'Quân của CPU',
  boardPlayerAlt: 'Bạn',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'hàng {row}, cột {col}',
  boardPlaceable: 'có thể đặt',
  boardEmpty: 'ô trống',
  boardFlower: 'có hoa',
  firstPlayerAlt: 'Người đi trước',
  playerFirst: 'Bạn đi trước!',
  playerSecond: 'Bạn đi sau (nhận thêm +{bonus}% komi)',
  cpuFirst: 'CPU đi trước!',
  finalePlayerWin: 'Bạn thắng!',
  finaleCpuWin: 'CPU thắng!',
  finaleFive: 'Năm quân liên tiếp!',
  finaleTerritory: 'Trận chiến lãnh thổ!',
  winnerAlt: 'Người thắng',
  loadingBoot: 'Đang khởi động...',
  loadingConnect: 'Đang kết nối...',
  loadingProfile: 'Đang tải hồ sơ...',
  loadingAssets: 'Đang tải tài nguyên...',
  loadingReady: 'Sẵn sàng',
  reauthRequiredTitle: 'Yêu cầu đăng nhập',
  startupFailedTitle: 'Khởi động thất bại',
  reauthButton: 'Đăng nhập lại',
  reloadButton: 'Tải lại',
  lineReloginButton: 'Đăng nhập LINE',
  reauthReason: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  errorReauth: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  errorForbidden: 'Bạn không có quyền tham gia trò chơi này.',
  errorNotFound: 'Không tìm thấy dữ liệu trò chơi.',
  errorRateLimited: 'Mạng đang bận. Vui lòng đợi và thử lại.',
  errorServer: 'Không thể kết nối với máy chủ. Vui lòng đợi và tải lại.',
  errorCommunication: 'Đã xảy ra lỗi giao tiếp. Vui lòng tải lại.',
  errorNetwork: 'Không thể kết nối mạng. Hãy kiểm tra kết nối và tải lại.',
  errorStartup: 'Khởi động thất bại. Vui lòng tải lại.',
  settingsTabGeneral: 'Cài đặt',
  settingsTabAccount: 'Tài khoản',
  settingsTabInfo: 'Thông tin',
  account: 'Tài khoản',
  linked: 'Đã liên kết',
  guest: 'Khách',
  loggedInWith: 'Đã đăng nhập bằng {provider}',
  loggedIn: 'Đã đăng nhập',
  playingAsGuest: 'Bạn đang chơi với tư cách là khách.',
  appleLoginBusy: 'Đang đăng nhập bằng Apple...',
  appleLogin: 'Đăng nhập bằng Apple',
  googleLoginBusy: 'Đang đăng nhập bằng Google...',
  googleLogin: 'Đăng nhập bằng Google',
  logoutBusy: 'Đang đăng xuất...',
  logout: 'Đăng xuất',
  logoutSuccess: 'Đã đăng xuất',
  logoutFailed: 'Đăng xuất thất bại',
  appInfo: 'Thông tin ứng dụng',
  appName: 'Tên ứng dụng',
  version: 'Phiên bản',
  legalInfo: 'Thông tin pháp lý',
  terms: 'Điều khoản sử dụng',
  privacy: 'Chính sách bảo mật',
  operator: 'Đơn vị vận hành',
  contact: 'Liên hệ',
  copyTap: 'Chạm để sao chép',
  idCopied: 'Đã sao chép ID',
  copyFailed: 'Sao chép thất bại',
  other: 'Khác',
  reportAd: 'Báo cáo quảng cáo không phù hợp',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Chỉnh sửa hồ sơ',
  displayName: 'Tên hiển thị',
  displayNamePlaceholder: 'Nhập tên',
  chooseIcon: 'Chọn biểu tượng',
  iconLoadFailed: 'Không thể tải danh sách biểu tượng.',
  saveFailed: 'Lưu thất bại. Vui lòng thử lại.',
  noIcons: 'Không có biểu tượng nào khả dụng.',
  save: 'Lưu',
  saving: 'Đang lưu...',
  staminaAria: 'Thể lực {stamina} / {max}',
  nextRecovery: 'Hồi phục tiếp theo sau {time}',
  adPlaying: 'Đang phát quảng cáo...',
  recoverFullAd: 'Xem quảng cáo để hồi đầy stamina',
  dailyBonusAria: 'Xem quảng cáo đến hết để nhận +5 stamina',
  dailyBonusAd: 'Xem quảng cáo để nhận +5 stamina',
  legalLastUpdated: 'Cập nhật lần cuối: {date}',
  privacyTitle: 'Chính sách bảo mật',
  termsTitle: 'Điều khoản sử dụng',
  adPlayingAria: 'Đang phát quảng cáo',
  adBadge: '▶ Quảng cáo',
  adRemaining: 'Còn {seconds} giây',
  adDevHint: 'Quảng cáo thử nghiệm. Trong bản chính thức, video AdMob sẽ được phát.',
  adRewardRequirement: 'Xem quảng cáo đến hết để nhận phần thưởng này.',
  adRewardStaminaDetail: 'Phần thưởng: hồi stamina đến mức tối đa',
  adRewardDailyBonusDetail: 'Phần thưởng: +{amount} stamina như thưởng hằng ngày',
  adRewardIncompleteNote: 'Nếu đóng trước khi kết thúc, bạn sẽ không nhận được thưởng.',
  adSkipAria: 'Bỏ qua quảng cáo',
  adSkip: 'Bỏ qua ✕',
  adSkipAfter: 'Bỏ qua sau {seconds} giây',
  offlineMessage: 'Không thể kết nối với máy chủ. Một số tính năng có thể không khả dụng.',
  reconnecting: 'Đang kết nối lại...',
  reconnect: 'Kết nối lại',
  signInTitle: 'Đăng nhập',
  signInBusy: 'Đang đăng nhập...',
  signInCancelNote: 'Nếu bạn hủy đăng nhập, bạn có thể tiếp tục chơi với tư cách khách (một số tính năng bị giới hạn).',
  processing: 'Đang xử lý...',
  recoverConfirmTitle: 'Xác nhận ghi đè dữ liệu',
  recoverConfirmMessage: 'Dữ liệu hiện có đã được liên kết với tài khoản này. Tiếp tục sẽ ghi đè dữ liệu khách trên thiết bị này. Bạn có muốn tiếp tục không?',
  recoverConfirmContinue: 'Khôi phục',
  recoverConfirmCancel: 'Hủy',
  unlinkConfirmTitle: 'Hủy liên kết tài khoản',
  unlinkConfirmMessage: 'Nếu bạn hủy liên kết với nhà cung cấp này, thiết bị sẽ quay lại chế độ chơi khách. Dữ liệu trên Hub vẫn khả dụng nếu bạn đăng nhập lại bằng cùng một nhà cung cấp trên thiết bị khác.',
  unlinkConfirmContinue: 'Hủy liên kết',
  unlinkConfirmCancel: 'Hủy',
  deleteConfirmTitle: 'Xác nhận xóa tài khoản',
  deleteConfirmMessage: 'Xóa tài khoản sẽ xóa điểm cao, dữ liệu đăng nhập, các tài khoản đã liên kết và lời mời.\nHành động này không thể hoàn tác. Bạn có thực sự muốn xóa không?',
  deleteConfirmContinue: 'Xóa tài khoản',
  deleteConfirmCancel: 'Hủy',
  adNekoTitle: 'Mèo Quảng Cáo',
  matchmakingRemaining: 'Còn {seconds} giây',
  matchmakingTimeoutMessage: 'Không tìm thấy đối thủ trong thời gian quy định. Vui lòng thử lại.',
  difficultyEasyName: 'Bình thường',
  difficultyEasyDescription: 'Đối thủ hơi lơ là một chút',
  difficultyNormalName: 'Trung bình',
  difficultyNormalDescription: 'Đối thủ thỉnh thoảng mắc lỗi',
  difficultyHardName: 'Khó',
  difficultyHardDescription: 'Đối thủ có tầm nhìn bao quát bàn cờ',
  difficultyHellName: 'Cực khó',
  difficultyHellDescription: 'Đối thủ rất mạnh và biết đọc trước nước đi',
}
